import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawEyeIcon from "./RawEyeIcon.svg.jsx";

const EyeIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawEyeIcon} {...props} />;
});

export default EyeIcon;
